import type { BrandCategoryKey } from './brandCategoryTypes'

const MANUFACTURER_LOGO: Record<string, BrandCategoryKey> = {
  apple: 'apple',
  samsung: 'samsung',
  google: 'google',
  oneplus: 'oneplus',
  motorola: 'motorola',
  sony: 'sony',
  xiaomi: 'xiaomi',
  nokia: 'nokia',
  honor: 'honor',
  asus: 'asus',
  huawei: 'huawei',
  nothing: 'nothing',
}

/** Map API manufacturer name → shop-by-brand logo key (when PNG exists). */
export function brandLogoKeyForManufacturer(name: string): BrandCategoryKey | null {
  return MANUFACTURER_LOGO[name.trim().toLowerCase()] ?? null
}
